module.exports = __webpack_public_path__ + "img/mensaje-pago_realizado.ee3a4234.png";